export const API_LOGIN = "/auth/login";
export const API_LOGOUT = "/logout";

export const API_USER_ME = "/user/me";
export const API_CHANGE_PASSWORD = "/user/changePassword";
export const API_USER = "/user";
export const API_USER_LIST = "/user/list";
export const API_USER_EXPORT = "/user/export";
export const API_USER_TREE = "/user/tree";
export const API_USER_LOCK = "/user/lock/{id}";
export const API_USER_UNLOCK = "/user/unlock/{id}";

export const API_SYSLOG_LIST = "/syslog/list";
export const API_SYSLOG_EXPORT = "/syslog/export";

export const API_SYSTEM_ENUMS = "/system/enums";
export const API_SYSTEM_IPC = "/system/ipc";

export const API_PERMISSION_LIST = "/permission/list";
export const API_PERMISSION = "/permission/{userId}";
export const API_PERMISSION_ALLOT_PROJECT = "/permission/allotProject/{projectId}/{userId}/{permission}";
export const API_PERMISSION_RECOVER_PROJECT = "/permission/recoverProject/{projectId}/{userId}";
export const API_PERMISSION_CHECK = "/permission/check/{projectId}";

export const API_BIS_LICENSE = "/license";

export const API_BIS_PROJECT = "/project/{id}";
export const API_BIS_PROJECT_CLONE = "/project/clone";
export const API_BIS_PROJECT_MERGE = "/project/merge";

export const API_BIS_IMPORT_PREVIEW = "/import/{projectId}/preview";
export const API_BIS_IMPORT_MAPPING = "/import/{projectId}/mapping";
export const API_BIS_IMPORT_SUBMIT = "/import/{projectId}/submit";
export const API_BIS_IMPORT_PROGRESS = "/import/{projectId}/progress";

export const API_BIS_UPLOAD_PATENT = "/upload/patent";

export const API_WIPS_SYNC_SUBMIT = "/wips/sync/submit";
export const API_WIPS_SYNC_PROGRESS = "/wips/sync/progress";

export const API_BIS_PATENT_LIST = "/patent/{projectId}/list";
export const API_BIS_PATENT_TREE = "/patent/{projectId}/tree";
export const API_BIS_PATENT_TREE_CHILDREN = "/patent/{projectId}/treechildren";
export const API_BIS_PATENT_FETCH_WIPS_DETAILS = "/patent/{projectId}/fetch-wips-details";
export const API_BIS_PATENT_BATCHDELETE = "/patent/{projectId}/batchdelete";
export const API_BIS_PATENT_CLEANDATALIST = "/patent/{projectId}/cleandatalist";
export const API_BIS_PATENT_CLEAN = "/patent/{projectId}/clean";
export const API_BIS_PATENT_BATCHINDEXING = "/patent/{projectId}/batchindexing";
export const API_BIS_PATENT_SINGLEINDEXING = "/patent/{projectId}/singleindexing";
export const API_BIS_PATENT_BATCHCATEGORY = "/patent/{projectId}/batchcategory";
export const API_BIS_PATENT_SINGLECATEGORY = "/patent/{projectId}/singlecategory";

export const API_BIS_CUSTOMFIELD_LIST = "/metadata/{projectId}/list";
export const API_BIS_CUSTOMFIELD = "/metadata/{projectId}/{id}";

export const API_BIS_PATENTTEXT = "/patenttext/{projectId}";
export const API_BIS_PATENTTEXT_PROGRESS = "/patenttext/{projectId}/progress";
export const API_BIS_PATENTTEXT_FULLTEXT = "/patenttext/{projectId}/fulltext/{patentId}";
export const API_BIS_PATENTTEXT_LEGALNOTE = "/patenttext/{projectId}/legalnote/{patentId}";

export const API_BIS_LISTLAYOUT = "/listlayout/{projectId}";

export const API_BIS_REPORT_STAT = "/report/{projectId}/stat";
export const API_BIS_REPORT_MODEL = "/report/{projectId}/model";
export const API_BIS_REPORT_CUSTOMIZED = "/report/{projectId}";
export const API_BIS_REPORT_CUSTOMIZED_WITH_ID = "/report/{projectId}/{id}";

export const API_BIS_FILTER = "/filter/{projectId}/{id}";
export const API_BIS_FILTER_TREE = "/filter/{projectId}/counttree";

export const API_BIS_CATEGORY_TREE = "/category/{projectId}/tree";
export const API_BIS_CATEGORY = "/category/{projectId}/{id}";
export const API_BIS_CATEGORY_SYNC = "/category/{projectId}/{id}/sync";

export const API_WARNING = "/opened/warning/{projectId}";

export const API_BIS_DATA_SYNC_SUBMIT = "/wips/sync/submit";
export const API_BIS_DATA_SYNC_PROGRESS = "/wips/sync/progress";
export const API_BIS_DATA_SYNC_TASKS = "/wips/sync/tasks";
export const API_BIS_DATA_SYNC_FAIL_LOGS = "/wips/sync/fail-logs";

// 下载和调用附图和原文PDF
export const API_BIS_DATA_DOWNLOAD = "/patent/{projectId}/download-assets";
export const API_BIS_ASSET = "/patent/{projectId}/asset";